import { useState, useEffect } from "react";
import Menu from "../../components/Menu";
import { useParams, useNavigate } from "react-router-dom";
import api from '../../services/api';
import Swal from 'sweetalert2'

import './Medicines.css'
import MedicinePills from '../../assets/img/pilulas-black.svg';
import Clear from '../../assets/img/remove.svg'
import LoadingBlock from "../../components/LoadingBlock";
import ModalYesNo from "../../components/ModalYesNo";
import FooterEdit from "../../components/FooterEdit";
import { Form } from "react-bootstrap";
import parseMaskedMoney from "../../utils/parseMaskedMoney";
import { formatCurrency } from "../../utils/formats";

export default function MedicinesEdit() {
    let { id } = useParams();
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState(false)

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({})

    const [name, setName] = useState("")
    const [businessname, setBusinessName] = useState("")
    const [registerMS, setRegisterMS] = useState("")
    const [descriptionDCB, setDescriptionDCB] = useState("")
    const [codeDCB, setCodeDCB] = useState("")
    //const [product, setProduct] = useState(null);
    const [presentation, setPresentation] = useState("")
    const [posologia, setPosologia] = useState("")
    const [isSpecial, setIsSpecial] = useState();
    const [price, setPrice] = useState(null);
    const [quant, setQuant] = useState(null);
    const [und, setUnd] = useState('');
    const [withoutMedication, setWithoutMedication] = useState(false);
    //const [externalCode, setExternalCode] = useState("")
    const [laboratory, setLaboratory] = useState("")

    const [stock, setStock] = useState('');
    const [costPrice, setCostPrice] = useState('');
    const [salePrice, setSalePrice] = useState('');

    useEffect(() => {
        setLoading(true);

        api.get('/api/pharmacydrugs/' + id).then((response) => {
            const data = response.data.data

            setCodeDCB(data.dcb_code)
            setDescriptionDCB(data.dcb_description || '')
            setName(data.name)
            setPosologia(data.dosage)
            setPresentation(data.presentation || '')
            setRegisterMS(data.code_ms || '')
            setIsSpecial(data.type === 'Normal' ? false : true)
            setPrice(data.price)
            setUnd(data.unit)
            setQuant(Math.floor(data.stock_available))
            //setExternalCode(data.external_code || '')
            setWithoutMedication(data.without_medication)
            setBusinessName(data.business_name || '')
            setStock(data.stock_available ? String(Math.floor(data.stock_available)) : '')
            setCostPrice(data.unit_price ? Number(data.unit_price).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }) : '')
            setSalePrice(data.price ? Number(data.price).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }) : '')
            setLaboratory(data.laboratory || '')
        }).catch((error) => {
            console.error('Error fetching agreements:', error);
        }).finally(() => {
            setLoading(false);
        })
    }, [id])

    const onDelete = () => {
        setShowModal(false)
        setLoading(true)
        api.delete("/api/pharmacydrugs/" + id).then((response) => {
            Swal.fire({
                title: "Medicamento excluído com sucesso",
                icon: 'success',
                confirmButtonColor: '#56CCF2',
            })
            setTimeout(() => {
                Swal.close()
                setTimeout(() => {
                    navigate('/medicines')
                }, 750);
            }, 1500);
        }).catch((error) => {
            console.error(error)
            Swal.fire({
                title: "Medicamento não excluído",
                text: error.message,
                icon: 'error',
                confirmButtonColor: '#56CCF2',

            })
        }).finally(() => {
            setLoading(false)
        })
    }

    const onSubmit = (ev) => {
        ev.preventDefault()
        var errors = {
            name: name.replaceAll(' ', '') === '' ? true : false,
            registerMS: (registerMS.replaceAll(' ', '') === '' || !registerMS) ? true : false,
            descriptionDCB: descriptionDCB.replaceAll(' ', '') === '' ? true : false,
            //prescriptionType: prescriptionType === "" ? true : false,
            //codeDCB: codeDCB.replaceAll(' ', '') === "" ? true : false,
            presentation: presentation.replaceAll(' ', '') === "" ? true : false,
            posologia: posologia.replaceAll(' ', '') === "" ? true : false,
            //externalCode: externalCode.replaceAll(' ', '') === "" ? true : false,
            stock: (stock <= 0 || stock.replaceAll(' ', '') === "") ? true : false,
            costPrice: parseMaskedMoney(costPrice) <= 0 ? true : false,
            salePrice: parseMaskedMoney(salePrice) <= 0 ? true : false,
        }
        setError(errors)
        var validations = true

        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key] === true) {
                validations = false;
            }
        }

        if (validations) {
            var form = new FormData();

            form.set('id', id);
            form.set('name', name);
            form.set('business_name', businessname);
            form.set('code_ms', registerMS);
            form.set('dcb_code', codeDCB);
            form.set('dcb_description', descriptionDCB);
            form.set('presentation', presentation);
            form.set('dosage', posologia);
            form.set('type', isSpecial ? 'Especial' : 'Normal');
            form.set('unit', und);
            form.set('unit_price', parseMaskedMoney(costPrice));
            form.set('box_price', 5);
            form.set('stock_quantity', 10);
            form.set('image', null);
            form.set('price', parseMaskedMoney(salePrice));
            form.set('stock_available', stock);

            form.set('external_code', null);
            form.set('without_medication', withoutMedication);
            form.set('laboratory', laboratory);

            setLoading(true)

            api.put("/api/pharmacydrugs", form).then((response) => {
                navigate("/medicines")

                Swal.fire({
                    title: "Medicamento editado com sucesso",
                    icon: 'success',
                    confirmButtonColor: '#56CCF2',
                })
            }).catch((error) => {
                console.error(error)
                Swal.fire({
                    title: "Medicamento não editado",
                    text: error.message,
                    icon: 'error',
                    confirmButtonColor: '#56CCF2',

                })
            }).finally(() => {
                setLoading(false)
            })
        }
    }
    const screenTela =
        <>
            {loading && <LoadingBlock />}
            <ModalYesNo show={showModal} setShow={setShowModal} affirnName={"Deletar"} negName={"Voltar"} afirmativeFunc={onDelete} message={"Ao excluir um registro não será possivel recuperar"} title={"Tem certeza?"} imgSVG={Clear} />

            <form onSubmit={onSubmit}>
                <div className='screenContainer edit-mode'>
                    <div className="containerTitle">
                        <h1 className="screenTitle">
                            <img style={{ width: '40px' }} alt="svg" src={MedicinePills} /> <span className="name-screen-title" >
                                Editar Medicamento
                            </span>
                        </h1>

                        <div>
                            {price !== null && <h2 style={{ textAlign: 'right', fontSize: '32px' }} className="screenTitle leftTile">Preço: <span className="fw-bold">R$ {Number(price).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</span></h2>}
                            {
                                //quant !== null && und !== '' && <h2 style={{ textAlign: 'right', fontSize: '32px' }} className="screenTitle leftTile"> {quant + ' ' + und + 'teste'}</h2>
                                quant !== null && <h2 style={{ textAlign: 'right', fontSize: '32px' }} className="screenTitle leftTile"> Quantidade: <span className="fw-bold">{quant}</span></h2>
                            }
                        </div>

                    </div>
                    <div className="row">
                        <h4 className="screenSubTitle">Dados Básicos</h4>

                        <div className="col-12 col-lg-6 col-xl-3 col-xxl-4 row gap-1" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label htmlFor="nameInput" className="form-label-input">Nome<mark>*</mark></label>
                                <input id="nameInput" className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                                {error.name && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12">
                                <label htmlFor="stockInput" className="form-label-input">Estoque disponível*</label>
                                <input id="stockInput" className="form-control" value={stock} type="number" name="stock" placeholder="Estoque" onChange={value => setStock(value.target.value)} />
                                {error.stock && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-lg-7 col-xl-7">
                                <label className="form-label-input">Unidade<mark>*</mark></label>
                                <select className="form-select" value={und} onChange={value => setUnd(value.target.value)}>
                                    <option value="DEFAULT" disabled hidden>Selecione a Unidade</option>
                                    <option value="AdT">ADESIVO TRANSDÉRMICO</option>
                                    <option value="Amp">AMPOLA</option>
                                    <option value="Bg">BISNAGA</option>
                                    <option value="Bl">BLISTER</option>
                                    <option value="Cp">COMPRIMIDO</option>
                                    <option value="Cj">CONJUNTO</option>
                                    <option value="Ct">CARTELA</option>
                                    <option value="Cx">CAIXA</option>
                                    <option value="Cap">CÁPSULA</option>
                                    <option value="Crt">CERATO (g)</option>
                                    <option value="Crm">CREME (g)</option>
                                    <option value="Drg">DRÁGEA</option>
                                    <option value="Elx">ELIXIR (ml)</option>
                                    <option value="Env">ENVELOPE</option>
                                    <option value="Fl">FLACONETE</option>
                                    <option value="Frs">FRASCO</option>
                                    <option value="g">GRAMA (g)</option>
                                    <option value="Gel">GEL (g)</option>
                                    <option value="Kt">KIT</option>
                                    <option value="Lt">LATA</option>
                                    <option value="Lo">LOÇÃO (g)</option>
                                    <option value="mg">MILIGRAMA (mg)</option>
                                    <option value="ml">MILILITRO (ml)</option>
                                    <option value="Pst">PASTILHA</option>
                                    <option value="Pct">PACOTE</option>
                                    <option value="Pmd">POMADA (g)</option>
                                    <option value="Pt">POTE</option>
                                    <option value="Sch">SACHÊ</option>
                                    <option value="Sup">SUPOSITÓRIO</option>
                                    <option value="Tb">TUBO</option>
                                    <option value="Und">UNIDADE</option>
                                    <option value="Ugn">UNGÜENTO (g)</option>
                                    <option value="Ovu">ÓVULO</option>
                                    <option value="Vd">VIDRO</option>
                                    <option value="Xp">XAROPE (ml)</option>
                                </select>

                            </div>

                            <div className="col-12">
                                <label htmlFor="codeDCBInput" inputMode="numeric" className="form-label-input">Código D.C.B.</label>
                                <input id="codeDCBInput" className="form-control" value={codeDCB} type="text" name="codeDCB" placeholder="Código D.C.B." onChange={value => setCodeDCB(value.target.value.replace(/\D/g, ''))} />
                                {/* {error.codeDCB && <span className="error" >Campo Inválido</span>} */}
                            </div>

                            <div className="col-12">
                                <label htmlFor="registerMSInput" className="form-label-input">Registro Ministério da Saúde<mark>*</mark></label>
                                <input id="registerMSInput" inputMode="numeric" className="form-control" value={registerMS} onChange={value => setRegisterMS(value.target.value.replace(/\D/g, ''))} type="text" name="registerMS" placeholder="Registro Ministério da Saúde" />
                                {error.registerMS && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>

                        <div className="col-12 col-lg-6 col-xl-5 col-xxl-4 row gap-1" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label htmlFor="businessNameInput" className="form-label-input">Nomes Comerciais (opcional)*</label>
                                <input id="businessNameInput" className="form-control" value={businessname} onChange={value => setBusinessName(value.target.value.toUpperCase())} type="text" name="commercialName" placeholder="Nome Comercial" />
                            </div>

                            <div className="col-12">
                                <label htmlFor="costPriceInput" className="form-label-input">Preço de custo*</label>
                                <input id="costPriceInput" className="form-control" value={costPrice} type="text" name="cost" placeholder="Preço de Custo" onChange={value => setCostPrice(formatCurrency(value.target.value))} />
                                {error.costPrice && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-lg-8 col-xl-8 d-flex align-items-end justify-content-between" style={{ height: '68px' }}>
                                <div>
                                    <label className="form-label-input">Tipo de Medicamento<mark>*</mark></label>
                                    <div>
                                        <div className="form-check form-check-inline">
                                            <input onChange={() => {
                                                setIsSpecial(!isSpecial)
                                            }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" checked={!isSpecial} />
                                            <label className="form-check-label" htmlFor="inlineRadio2">Normal</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input onChange={() => {
                                                setIsSpecial(!isSpecial)
                                            }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" checked={isSpecial} />
                                            <label className="form-check-label" htmlFor="inlineRadio1">Especial</label>
                                        </div>
                                    </div>
                                    {error.prescriptionType && <span className="error" >Campo Inválido</span>}
                                </div>

                                <div className="d-flex align-items-center">
                                    <Form.Check
                                        id="missing-medicine"
                                        label="Em falta"
                                        checked={withoutMedication}
                                        onChange={() => setWithoutMedication(!withoutMedication)}
                                    />
                                </div>
                            </div>

                            <div className="col-12">
                                <label htmlFor="descriptionDCBInput" className="form-label-input">Descrição D.C.B.<mark>*</mark></label>
                                <input id="descriptionDCBInput" className="form-control" value={descriptionDCB} onChange={value => setDescriptionDCB(value.target.value)} type="text" name="descriptionDCB" placeholder="Descrição D.C.B." />
                                {error.descriptionDCB && <span className="error" >Campo Inválido</span>}
                            </div>

                            {/* <div className="col-12">
                                <label htmlFor="externalCodeInput" className="form-label-input">Código de integração<mark>*</mark></label>
                                <input id="externalCodeInput" className="form-control" value={externalCode} onChange={value => setExternalCode(value.target.value)} type="text" name="externalCode" placeholder="Código de integração" />
                                {error.externalCode && <span className="error" >Campo Inválido</span>}
                            </div> */}

                            <div className="col-12">
                                <label htmlFor="laboratoryInput" className="form-label-input">Laboratório (opcional)*</label>
                                <input id="laboratoryInput" className="form-control" value={laboratory} onChange={value => setLaboratory(value.target.value.toUpperCase())} type="text" name="externalCode" placeholder="Laboratório" />
                            </div>
                        </div>

                        <div className="col-12 col-xl-4 col-xxl-4 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label htmlFor="presentationInput" className="form-label-input">Apresentação<mark>*</mark></label>
                                <input id="presentationInput" className="form-control" value={presentation} onChange={value => setPresentation(value.target.value.toUpperCase())} type="text" name="presentation" placeholder="Apresentação" />
                                {error.presentation && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12" style={{ marginTop: '0.75rem' }}>
                                <label htmlFor="salePriceInput" className="form-label-input">Preço de venda*</label>
                                <input id="salePriceInput" className="form-control" value={salePrice} type="text" name="sale" placeholder="Preço de Venda" onChange={value => setSalePrice(formatCurrency(value.target.value))} />
                                {error.salePrice && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12">
                                <label htmlFor="posologiaInput" className="form-label-input">Posologia<mark>*</mark></label>
                                <textarea style={{ height: 'auto' }} rows={11} id="posologiaInput" className="form-control" value={posologia} type="text" name="posologia" placeholder="Posologia" onChange={value => setPosologia(value.target.value.toUpperCase())} />
                                {error.posologia && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>
                    </div>
                </div>
                <FooterEdit navigateRoute={"/medicines"} onClickDel={() => {
                    setShowModal(true)
                }} />
            </form>
        </>

    return (
        <Menu screen={screenTela} />
    )
}